


































import Vue from 'vue';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import ProgressBar from '@/components/ProgressBar.vue';
import BottomButton from '@/components/BottomButton.vue';
import pipeline from '@/pipeline';
import LoadingPage from '@/components/LoadingPage.vue';
import { Toast } from '@/components/ds';
import VueMarkdown from 'vue-markdown';
import { AnalyticsActions } from '@/store/modules/analytics/actions';
import IdleMonitor from '@/components/IdleMonitor.vue';

export default Vue.extend({
  components: {
    BottomButton,
    PipelineMenuWrapper,
    ProgressBar,
    LoadingPage,
    Toast,
    VueMarkdown,
    IdleMonitor,
  },
  data() {
    return {
      hasReachedBottom: false,
      scrollProgress: 0,
      isLoading: false,
      error: false,
    };
  },
  computed: {
    isContinueEnabled(): boolean {
      return this.isContractEmbedPDF ? true : this.hasReachedBottom && !this.error;
    },
    contractHtml(): string {
      return this.$store.getters.contractHtml;
    },
    isContractEmbedPDF(): boolean {
      return this.contractHtml.includes('<object');
    },
  },
  async created() {
    this.isLoading = true;
    await this.$store.dispatch('PULL_CONTRACT_HTML');

    if (!this.contractHtml) {
      await this.$store.dispatch('GENERATE_CONTRACT');
      await this.$store.dispatch('PULL_CONTRACT_HTML');
    }
    this.isLoading = false;
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    async continueHandler() {
      try {
        this.isLoading = true;

        await this.$store.dispatch('ACCEPT_CONTRACT');

        await this.$store.dispatch(AnalyticsActions.ENROLLMENT_CONTRACT_ACCEPTED);

        if (this.$gtag)
          this.$gtag.event('Conclusão de Matrícula', {
            event_category: 'Processo de Matrícula',
          });

        pipeline.next();
      } catch (err) {
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 3000);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },
    onScroll() {
      const pageHeight = document.documentElement.offsetHeight - 20; // offset of 20px (we have found some issues on windows version of chrome related to document.documentElement.offsetHeight)

      const pageCurrentHeight = window.pageYOffset + window.innerHeight;

      this.scrollProgress = Math.floor(
        (window.pageYOffset * 100) / (pageHeight - window.innerHeight),
      );

      this.hasReachedBottom = pageCurrentHeight >= pageHeight;
    },
    onidle() {
      if (window && window.bmMaximize) {
        window.bmMaximize();
      }
    },
  },
});
